// ─────────────────────────────────────────────────────────────────────────────
// 🔑 WHERE ARE THIS BORROWER'S DOCUMENTS? — the client half of backend utils/borrowerDocumentsLink (2026-10-16).
// Every borrower's documents are on /documents (cleanup Phase 2, Jesse 2026-10-28/29 — the classic Verification
// page is gone). An old /verification link (old emails, old installed app builds, stored alert targets) is still
// mapped here, and the /verification route itself redirects the same way (components/VerificationRoute).
// ─────────────────────────────────────────────────────────────────────────────

/** A /verification path, mapped. Anything else is returned unchanged. (`guided` is kept for old callers; ignored.) */
export function documentsPathFor(_guided, path) {
  const p = String(path || '');
  if (!/^\/verification(?:[?#]|$)/.test(p)) return p;
  // 🚨 An old ?addAssets=1 link lands on Documents like any other (Jesse, 2026-11-02): the post-decision "Add assets"
  // is removed — after a decision, changes go through "Request a change".
  return '/documents#action-needed';
}

/** Synchronous form for link props. */
export function docsPath(path) { return documentsPathFor(true, path); }
